export default () => ({
  interests: [],
  isOverlay: false,
  display: false,

  initInterests(isOverlay) {
    this.isOverlay = isOverlay;

    CF.customerReady(
      function () {
        this.interests = CF.customer.get("preference_interests") || [];
        if (this.interests.length > 0 && this.isOverlay) {
          this.display = false;
        } else {
          this.display = true;
        }
      }.bind(this)
    );
  },
});
